export default {"src":"/evde-internet/_next/static/media/red-network.b40b6cd9.svg","height":32,"width":32};